import React from "react";
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import "./AppuntamentoPuntoAcquaCase.css";

const AppuntamentoPuntoAcquaCase = () => (
  <div
    className="AppuntamentoPuntoAcquaCase"
    data-testid="AppuntamentoPuntoAcquaCase"
  >
    {/* <div style={{display: 'flex', justifyContent: 'center'}}>
    <img src={prenotaImg} style={{marginTop:'100px', width: '80%',marginBottom:'0px', height: '50%'}} />
    </div> */}
    <CaseGenerator type={CaseForms.AppuntamentoPuntoAcqua}/>
  </div>
);

export default AppuntamentoPuntoAcquaCase;
